import { styled } from '@glitz/react';

export const enum Theme {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Quaternary = 'quaternary',
  Monochrome = 'monochrome',
  MonochromeBrighter = 'monochromeBrighter',
  Positive = 'positive',
  Negative = 'negative',
  Transparent = 'transparent',
  White = 'white',
  Dark = 'dark',
  Disabled = 'disabled',
  CarouselButton = 'carouselButton',
  SecondaryCarouselButton = 'secondaryCarouselButton',
  ActionButton = 'actionButton',
  LinkButton = 'linkButton',
  FilterButton = 'filterButton',
  WishlistButton = 'wishlistButton',
}

type ValueOf<T> = T[keyof T];
export type ThemeType = ValueOf<typeof Theme>;

export const SiteTheme = {
  NordicNest: 'nordicnest',
  Svenssons: 'svenssons',
  Kitchentime: 'kitchentime',
  Lightshop: 'lightshop',
} as const;

export const isNordicNest = __SITE__ === SiteTheme.NordicNest;
export const isSvenssons = __SITE__ === SiteTheme.Svenssons;
export const isKitchentime = __SITE__ === SiteTheme.Kitchentime;
export const isLightshop = __SITE__ === SiteTheme.Lightshop;

export function createThemeDecorator(type: ValueOf<typeof Theme>) {
  return styled({
    backgroundColor: t => t[type].color,
    color: t => t[type].text,
  });
}

export function lighten(hex: string, lightness: number) {
  // Convert hex to RGB first
  let r: any = 0,
    g: any = 0,
    b: any = 0;
  if (hex.length === 4) {
    r = '0x' + hex[1] + hex[1];
    g = '0x' + hex[2] + hex[2];
    b = '0x' + hex[3] + hex[3];
  } else if (hex.length === 7) {
    r = '0x' + hex[1] + hex[2];
    g = '0x' + hex[3] + hex[4];
    b = '0x' + hex[5] + hex[6];
  }
  // Then to HSL
  r /= 255;
  g /= 255;
  b /= 255;
  const cmin = Math.min(r, g, b),
    cmax = Math.max(r, g, b),
    delta = cmax - cmin;
  let h = 0,
    s = 0,
    l = 0;

  if (delta === 0) h = 0;
  else if (cmax === r) h = ((g - b) / delta) % 6;
  else if (cmax === g) h = (b - r) / delta + 2;
  else h = (r - g) / delta + 4;

  h = Math.round(h * 60);

  if (h < 0) h += 360;

  l = (cmax + cmin) / 2;
  s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
  s = +(s * 100).toFixed(1);

  return 'hsl(' + h + ',' + s + '%,' + lightness + '%)';
}

export const isNordicnestTheme = __SITE__ === 'nordicnest';
